/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { UserStatsDto } from '../models/user-stats-dto';

@Injectable({
  providedIn: 'root',
})
export class GeneratedUserStatsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getUserStats
   */
  static readonly GetUserStatsPath = '/api/user-stats/{userId}';

  /**
   * Gets statistics about a specific user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserStats$Response(params: {
    userId: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserStatsDto>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedUserStatsService.GetUserStatsPath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserStatsDto>;
      })
    );
  }

  /**
   * Gets statistics about a specific user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserStats(params: {
    userId: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<UserStatsDto> {

    return this.getUserStats$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserStatsDto>) => r.body as UserStatsDto)
    );
  }

}
